import { GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY } from "../../../../operations/queries/operations/queries/get-stores-by-distance.js";
import { mapStoresResult } from "../../../../hooks/api/adapters/hooks/api/adapters/mapStoresResult.js";
async function getStores(apolloClient, { coordinates: { lat, lon }, locale, maxResults = 30, forceDistance }) {
  const variables = {
    searchGeoLocation: { lat, lon },
    maxResults,
    forceDistance
  };
  try {
    const { data, error } = await apolloClient.query({
      query: GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY,
      variables,
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      }
    });
    if (error) {
      console.error(error);
      throw new Error(error.message);
    }
    return mapStoresResult(data.storesByDistance);
  } catch (e) {
    console.error(`Failed to query stores: ${e}`);
    return [];
  }
}
export {
  getStores
};
//# sourceMappingURL=data.js.map
